// extracted by mini-css-extract-plugin
export default {"wrapper":"Root_wrapper__TMRrZ"};